//import { getUrl } from "../App";

//export const base_url = getUrl();
const REACT_APP_BASE_URL = import.meta.env.VITE_BASE_URL;

export const isDev = import.meta.env.VITE_APP_ENV === 'uat';

// export const base_url = "https://mkisanservice.mahindra.com";//production
// export const base_url="https://mkisanservice.mahindra.com";
// export const base_url = "https://7758-103-224-241-11.ngrok.io";
// export const base_url ="https://mkisanservice-uat.m-devsecops.com";
// export const base_url = "https://mkisanservice-dev.m-devsecops.com"
// export const base_url = "https://blue-pianos-fail-103-224-241-11.loca.lt";

export const kmsLoginApi = `${REACT_APP_BASE_URL}/api/kms/v2/login`;

export const kmsLogoutApi = `${REACT_APP_BASE_URL}/api/kms/logout`;

export const getInterestsApi = `${REACT_APP_BASE_URL}/api/kms/getUserInterestExpertise`;

export const addInterestApi = `${REACT_APP_BASE_URL}/api/kms/updateUserInterest`;

export const addExpertiseApi = `${REACT_APP_BASE_URL}/api/kms/updateUserExpertise`;

//export const deleteExpertiseApi = `${base_url}/api/kms/login`;

export const getSubSystemApi = `${REACT_APP_BASE_URL}/api/kms/getMasterSubSystem`;

export const getSystemApi = `${REACT_APP_BASE_URL}/api/kms/getMasterSystem`;

export const getPlatformApi = `${REACT_APP_BASE_URL}/api/kms/getMasterPlatform`;

export const getDivisionApi = `${REACT_APP_BASE_URL}/api/kms/getMasterDivision`;

export const getSystemSubsystemApi = `${REACT_APP_BASE_URL}/api/kms/getMasterSystemSubsystem`;

export const getFilteredKnowledgeApi = `${REACT_APP_BASE_URL}/api/kms/getKnowledgeByDate`;

export const getAllKnowledgeApi = `${REACT_APP_BASE_URL}/api/kms/getDashboardData`;

export const askAQueryApi = `${REACT_APP_BASE_URL}/api/kms/addQuestion`;

export const createKnowledgeApi = `${REACT_APP_BASE_URL}/api/kms/addKnowledge`;

export const addAnswerApi = `${REACT_APP_BASE_URL}/api/kms/addAnswer`;

export const addCommentApi = `${REACT_APP_BASE_URL}/api/kms/createComment`;

export const likeApi = `${REACT_APP_BASE_URL}/api/kms/addRemoveLikes`;

export const questionsAnsweredbyMeApi = `${REACT_APP_BASE_URL}/api/kms/answerAddedByMe`;

export const knowledgeCreatedbyMeApi = `${REACT_APP_BASE_URL}/api/kms/knowledgeCreatedByMe`;

export const questionsForMeApi = `${REACT_APP_BASE_URL}/api/kms/getExpertiseQuestion`;

export const questionDetailsApi = `${REACT_APP_BASE_URL}/api/kms/getAllAnswers/`;

export const getDetailsApi = `${REACT_APP_BASE_URL}/api/kms/getDetailsData`;

export const getBookmarksApi = `${REACT_APP_BASE_URL}/api/kms/getAllBookmarks`;

export const getQueByMeApi = `${REACT_APP_BASE_URL}/api/kms/getAskedByMe`;

export const searchByKeywordApi = `${REACT_APP_BASE_URL}/api/kms/searchByKeyWord`;

export const searchByTagApi = `${REACT_APP_BASE_URL}/api/kms/searchByTag`;

export const masterSearchApi = `${REACT_APP_BASE_URL}/api/kms/masterSearch`;

export const getUsefulLinksApi = `${REACT_APP_BASE_URL}/api/kms/getUsefullLinks`;

export const updateBookmarksApi = `${REACT_APP_BASE_URL}/api/kms/addRemoveBookmarks`;

export const getGuidelinesApi = `${REACT_APP_BASE_URL}/api/kms/getGuidelines`;

export const getCreatorsApi = `${REACT_APP_BASE_URL}/api/kms/getCreatorNameList`;

export const usefulLinkSearchApi = `${REACT_APP_BASE_URL}/api/kms/searchLinkByTitle`;

export const eventsGalleryApi = `${REACT_APP_BASE_URL}/api/kms/getEventGallery`;

export const getProfileDetailsApi = `${REACT_APP_BASE_URL}/api/kms/getUserUpdatedProfile`;

export const getEventsApi = `${REACT_APP_BASE_URL}/api/kms/getUserActivityData`;

export const getUpcomingEventsApi = `${REACT_APP_BASE_URL}/api/kms/upcomingevents`;

export const getNotificationsApi = `${REACT_APP_BASE_URL}/api/kms/getNotification`;

export const markReadNotificationApi = `${REACT_APP_BASE_URL}/api/kms/readNotification`;

export const getToken = `${REACT_APP_BASE_URL}/api/kms/getToken`;

export const getTicker = `${REACT_APP_BASE_URL}/api/kms/getTicker`;

export const getMDTUsers = `${REACT_APP_BASE_URL}/api/kms/getMDTUsers`;

export const getEventGalleryById = `${REACT_APP_BASE_URL}/api/kms/getEventGalleryById`;

export const getTickerV2 = `${REACT_APP_BASE_URL}/api/kms/v2/getTicker`;

export const getAllPostsQuestions = `${REACT_APP_BASE_URL}/api/kms/home/getAllPostsQuestions`;

export const getAllBookmarks = `${REACT_APP_BASE_URL}/api/kms/home/getAllBookmarks`;

export const searchAllPostsQuestionsWithFilters = `${REACT_APP_BASE_URL}/api/kms/home/searchAllPostsQuestionsWithFilters`;

export const getAllKnowledgeBaseDataById = `${REACT_APP_BASE_URL}/api/kms/getAllKnowledgeBaseDataById`;

export const getKnowledgeCreatedByMe = `${REACT_APP_BASE_URL}/api/kms/home/getKnowledgeCreatedByMe`;

// #region SSO
export const authenticate = `${REACT_APP_BASE_URL}/api/authentication/app`;

export const whoami = `${REACT_APP_BASE_URL}/api/authentication/whoami`;

export const login = `${REACT_APP_BASE_URL}/api/authentication1/ssoSuccess`;

export const logout = `${REACT_APP_BASE_URL}/api/authentication/logout`;
// #endregion

export const likeDislike = `${REACT_APP_BASE_URL}/api/kms/v2/likeDislike`;

export const createComment = `${REACT_APP_BASE_URL}/api/kms/v2/createComment`;

export const createAnswer = `${REACT_APP_BASE_URL}/api/kms/v2/createAnswer`;

export const generateSignedPlaylistFile = `${REACT_APP_BASE_URL}/api/kms/generateSignedPlaylistFile`;
